var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-select',{attrs:{"options":_vm.languages,"text-field":"name","value-field":"language_id"},model:{value:(_vm.locale),callback:function ($$v) {_vm.locale=$$v},expression:"locale"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }